import { styled } from "@acko-tech/building-blocks.ui.common";

export const FilterChipsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin: 0 0 20px 0;
`;

export const FilterChip = styled.div<{ selected?: boolean }>`
  border-radius: 24px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  background: ${({ selected }) =>
    selected
      ? "var(--text-primary-n-600, #040222)"
      : "var(--background-white-n-0, #fff)"};
  color: ${({ selected }) =>
    selected
      ? "var(--background-white-n-0, #fff)"
      : "var(--text-primary-n-600, #040222)"};
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  text-transform: capitalize;
`;
